import { Add, DeleteOutline } from '@mui/icons-material';
import { Box, Button, Divider, Grid2 as Grid, IconButton, Stack, TextField, Typography } from '@mui/material';
import { DailyNavFtpConfigProps } from './DailyNavFtpConfig.props';

const DailyNavFtpConfig = ({
  disabled,
  ftpHost,
  ftpPort,
  ftpPath,
  ftpUsername,
  onFtpHostChange,
  onFtpPortChange,
  onFtpPathChange,
  onFtpUsernameChange,
  deliveryRecipients,
  onAddDeliveryRecipient,
  onRemoveDeliveryRecipient,
  onDeliveryRecipientChange,
  isDeliveryEmailInvalid,
}: DailyNavFtpConfigProps) => (
  <>
    <Divider sx={{ my: 3 }} />
    <Typography variant="h4" gutterBottom>
      Delivery
    </Typography>
    <Typography variant="body2" sx={{ mb: 2 }}>
      Delivery recipients are emailed the report when it is sent. If an SFTP host is configured, the
      report is also uploaded with key-based authentication.
    </Typography>
    <Grid container spacing={2} sx={{ mb: 2 }}>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-host"
          label="SFTP host"
          value={ftpHost}
          onChange={event => onFtpHostChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 3 }}>
        <TextField
          fullWidth
          size="small"
          type="number"
          id="daily-nav-ftp-port"
          label="Port"
          value={ftpPort}
          onChange={event => onFtpPortChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-path"
          label="Path"
          value={ftpPath}
          onChange={event => onFtpPathChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
      <Grid size={{ xs: 12, sm: 6 }}>
        <TextField
          fullWidth
          size="small"
          id="daily-nav-ftp-username"
          label="Username"
          value={ftpUsername}
          onChange={event => onFtpUsernameChange(event.target.value)}
          disabled={disabled}
        />
      </Grid>
    </Grid>
    <Typography variant="body2" sx={{ mb: 2 }}>
      Delivery recipients
    </Typography>
    <Stack spacing={2}>
      {deliveryRecipients.map((recipient, index) => (
        <Grid container spacing={2} key={recipient.key} alignItems="center">
          <Grid size={{ xs: 10, sm: 6 }}>
            <TextField
              fullWidth
              size="small"
              type="email"
              placeholder="e.g. delivery@firm.com"
              data-testid={`daily-nav-delivery-recipient-${index}`}
              value={recipient.email}
              onChange={event => onDeliveryRecipientChange(index, event.target.value)}
              error={isDeliveryEmailInvalid(recipient.email)}
              disabled={disabled}
            />
          </Grid>
          <Grid size={{ xs: 2, sm: 1 }} sx={{ textAlign: 'right' }}>
            <IconButton
              color="error"
              data-testid={`daily-nav-delivery-recipient-remove-${index}`}
              onClick={() => onRemoveDeliveryRecipient(index)}
              disabled={disabled}>
              <DeleteOutline />
            </IconButton>
          </Grid>
        </Grid>
      ))}
    </Stack>
    <Box sx={{ mt: 2 }}>
      <Button
        startIcon={<Add />}
        onClick={onAddDeliveryRecipient}
        variant="text"
        id="daily-nav-add-delivery-recipient"
        disabled={disabled}>
        Add Recipient
      </Button>
    </Box>
  </>
);

export default DailyNavFtpConfig;
